import selectBranch from './selectBranch';

export default async function browseAreaHome(area, user, reload = () => window.location.assign('/')) {
  await selectBranch(area, user);
  // A previous direct store visit must not redirect the marketplace back to that store.
  try { window.sessionStorage.removeItem('customerHomePath'); } catch { /* Storage can be disabled. */ }
  reload();
}
